import React, { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';

const CustomDropdown = ({ dropdownList, drowdownButtonClassName, buttonText, buttonIcon, itemClassName, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => setIsOpen((prev) => !prev);
    const closeDropdown = () => setIsOpen(false);
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return (
        <div className="dropdown-group" ref={dropdownRef}>
            <button className={cn('db-card-filter-btn dropdown-btn', drowdownButtonClassName)} onClick={toggleDropdown}>
                {buttonIcon && <i className={cn('lab lab-font-size-17', buttonIcon)}></i>}
                {buttonText && <span>{buttonText}</span>}
            </button>
            <div className={cn('dropdown-list db-card-filter-dropdown-list', isOpen ? 'active' : '')}>
                {dropdownList?.map((item, index) => (
                    <button key={index} className={cn('dropdown-item db-card-filter-dropdown-menu', itemClassName)} onClick={item.dropDownAction}>
                        {item.icon && <i className={cn('lab lab-font-size-17', item?.icon)}></i>}
                        {item.text}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CustomDropdown;
